//            _   _ _______ _____     _____             __ _
//      /\   | \ | |__   __|  __ \   / ____|           / _(_)
//     /  \  |  \| |  | |  | |  | | | |     ___  _ __ | |_ _  __ _
//    / /\ \ | . ` |  | |  | |  | | | |    / _ \| '_ \|  _| |/ _` |
//   / ____ \| |\  |  | |  | |__| | | |___| (_) | | | | | | | (_| |
//  /_/    \_\_| \_|  |_|  |_____/   \_____\___/|_| |_|_| |_|\__, |
//                                                            __/ |
//                                                           |___/

import type { ThemeConfig } from "antd";

import getThemeDefault from "@/base/theme/theme-config.default";
import DesignConfig from "@/theme/design.config";

export type ThemeCallback = (mode: string) => ThemeConfig;
const getTheme: ThemeCallback = (mode) => {
	const cfg: ThemeConfig = Object.assign({}, getThemeDefault(mode));
	const currentDesignConfig = DesignConfig.hasOwnProperty(mode) ? DesignConfig[mode] : DesignConfig["light"];
	cfg.components = {
		...cfg.components,
		Menu: {
			...cfg.components?.Menu,
			itemSelectedBg: "white",
			itemSelectedColor: DesignConfig[mode].primaryColor,
		},
		Checkbox: {
			...cfg.components?.Checkbox,
			colorPrimary: "white",
			colorText: "white",
		},
		InputNumber: {
			...cfg.components?.InputNumber,
			colorText: "white",
			activeBorderColor: "white",
			colorPrimary: "white",
			handleHoverColor: "white",
			activeBg: "transparent",
			activeShadow: "none",
			colorTextPlaceholder: "#808080",
		},
		Select: {
			optionActiveBg: "#1A70FF",
			selectorBg: `#0A1732 !important`,
			controlItemBgActive: `${currentDesignConfig.primaryTint["200"]}`,
			colorTextPlaceholder: currentDesignConfig.textColor,
			colorTextQuaternary: currentDesignConfig.textColor,
			colorBgContainer: currentDesignConfig.mainBgColor,
		},
		Input: {
			...cfg.components?.Input,
			colorBorder: "transparent",
			colorTextPlaceholder: "#FCFCFC",
			colorBgContainer: "#040B18",
		},
		Dropdown: {
			...cfg.components?.Dropdown,
			colorTextDescription: "#FCFCFC",
			controlItemBgActive: "rgba(252,252,252,0.53)",
			colorPrimary: "#323233",
		},
		Progress: {
			...cfg.components?.Progress,
		},
		Pagination: {
			...cfg.components?.Pagination,
			itemActiveBg: "#1A70FF",
			colorBgContainer: "#040B18",
			colorBorder: "transparent",
			colorPrimary: "white",
		},

		Card: {
			headerBg: "#0A1732",
			colorBgContainer: "#030A17",
		},

		Table: {
			headerBg: "#0A1732",
			borderColor: currentDesignConfig.borderColor,
			colorSplit: currentDesignConfig.borderColor,
			headerSplitColor: currentDesignConfig.borderColor,
		},

		Button: {
			...cfg.components?.Button,
			defaultBg: "#0A1732",
			colorText: "white",
			colorBorder: "transparent",
		},
	};

	// Custom definitions here
	// doc - https://ant.design/docs/react/customize-theme/

	return cfg;
};

export default getTheme;
